import { ACTION, GenericObject, actionKeyGenerate } from "src/util/utils";

export const MODULE_KEY = "FEDEX";

export const KEYS: GenericObject = actionKeyGenerate(MODULE_KEY);

export const FEDEX_FETCH = KEYS[MODULE_KEY + ACTION.FETCH];

export const fetchFedEx = (payload: any) => ({
  type: FEDEX_FETCH,
  payload,
});

export const fetchFedExSuccess = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.SUCCESS],
  payload,
});

export const fetchFedExFailed = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.FAILED],
  payload,
});
